import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Redirect } from "react-router-dom";
import { Grid } from '@material-ui/core';
import { API_URL } from '../constants';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import LoggedInTopMenu from '../components/LoggedInTopMenu';
import SideMenu from '../components/SideMenu';
import Hidden from '@material-ui/core/Hidden';
import axios from 'axios';
import AddIcon from '@material-ui/icons/Add';
import DataTable from 'react-data-table-component';
import TextField from '@material-ui/core/TextField';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles(theme => ({
    content: {
      paddingTop: 130,
      marginLeft: '-6%'
    },
    sideMenu: {
      backgroundColor: '#9F0000',
      width: 256,
      height: `calc(100vh - 130px)`,
      borderTopRightRadius: 75,
      color: '#fff',
      paddingTop: 70
    },
    mainContent: {
      width: `calc(100% - 256px)`,
      textAlign: 'left',
      ['@media (max-width:959px)']: { 
        width: '92%',
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    article: {
      paddingTop: 20,
      paddingLeft: 50
    },
    activePageHeader: {
        fontSize: 20,
        fontWeight: 'bold',
        paddingRight: 40,
        color: '#000',
        textDecoration: 'none',
    },
    history: {
        width: '100%',
        marginTop: 40,
    },
    header: {
        color: '#000',
        opacity: 0.25,
        fontSize: 16,
        paddingBottom: 39,
        textAlign: 'center'
    },
    headerLeft: {
        color: '#000',
        opacity: 0.25,
        fontSize: 16,
        paddingBottom: 39,
        textAlign: 'left'
    },
    left: {
        textAlign: 'left',
        height: 80,
        borderBottomWidth: 1,
        borderBottomColor: '#d3d3d3',
        borderBottomStyle: 'solid'
    },
    center: {
        textAlign: 'center',
        height: 80,
        borderBottomWidth: 1,
        borderBottomColor: '#d3d3d3',
        borderBottomStyle: 'solid',
        fontSize: 14
    },
    amount: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        height: 80,
        borderBottomWidth: 1,
        borderBottomColor: '#d3d3d3',
        borderBottomStyle: 'solid'
    },
    complete: {
        fontSize: 12,
        color: '#48D1B5',
        border: 'solid 1px #48D1B5',
        fontWeight: 'bold',
        width: 80,
        margin: '0 auto',
        borderRadius: 10,
        ['@media (max-width:768px)']: { 
          width: 'initial',
          textAlign: 'center'
        }
    },
    name: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    car: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#000',
        opacity: 0.25
    },
    customer: {
        width: 36,
        height: 36,
        borderRadius: 10,
        objectFit: 'cover',
        marginRight: 12
    },
    client: {
        display: 'flex',
        ['@media (max-width:768px)']: { 
          display: 'block'
        }
    },
    colAdd: {
        paddingLeft: '3%',
        height: 60,
        borderBottomWidth: 1,
        borderBottomColor: '#d3d3d3',
        borderBottomStyle: 'solid',
        ['@media (max-width:768px)']: { 
          width: '100%',
          paddingLeft: 0
        }
    },
    addService: {
        textDecoration: 'none',
        color: '#9F0000'
    },
    addIcon: {
        position: 'absolute'
    },
    addServiceText: {
        marginLeft: 30,
    },
    serviceLink: {
        color: '#9F0000'
    },
    filterContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 15,
        marginBottom: 20,
        width: '30%',
        justifyContent: 'space-between',
        ['@media (max-width:959px)']: { 
            width: '100%',
        }
    },
    input: {
        width: 280,
        fontSize: 16
    },
}));

const Buildings = () => {
    const classes = useStyles();
    const userId = localStorage.getItem('userId');
    const roleId = localStorage.getItem('roleId');
    let [language, setLanguage] = useState('');
    let [buildings, setBuildings] = useState([]);
    let [allBuildings, setAllBuildings] = useState([]);
    let [searchKeyword, setSearchKeyword] = useState('');
    let [columns, setColumns] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const { t, i18n } = useTranslation();

    const CustomTitle = ({ row }) => (
        <div>
            {}
            <div>
                <div
                    data-tag="allowRowEvents"
                    style={{ color: 'grey', overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}
                >
                    {}
                    <a className={classes.serviceLink} href={`/building/${row.id}`}>{language == 'ar' ? row.name_ar : row.name}</a>
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        const language = localStorage.getItem('language');
        if(language) {
            i18n.changeLanguage(language);
        }
        setLanguage(language);

        getBuildings();
        let table_columns = [
            {
                name: t('buildings.name'),
                selector: row => row.name,
                sortable: true,
                cell: row => <CustomTitle row={row} />,
            },
            {
                name: t('buildings.address'),
                selector: row => row.address,
                sortable: true,
            },
        ];
        setColumns(table_columns);
    }, [])

    if (!userId) {
        return <Redirect to={'/'} />;
    }

    const getBuildings = () => {
        axios.get(API_URL + `/properties`)
        .then(response => {
            let bldgs = response.data.properties;
            let all_bldgs = bldgs;
            if(roleId == 5) {
                axios.get(API_URL + `/manager-properties`)
                .then(resp => {
                    let manager_properties = resp.data.manager_properties;
                    let filtered_bldgs = []
                    if(all_bldgs?.length > 0) {
                        filtered_bldgs = all_bldgs.filter(mp => {
                            return manager_properties?.some(a => a.property_id == mp.id && a.user_id == userId)
                        })
                    } else {
                        filtered_bldgs = all_bldgs
                    }
                    setAllBuildings(filtered_bldgs);
                    setBuildings(filtered_bldgs);
                })
            } else {
                setAllBuildings(all_bldgs);
                setBuildings(bldgs);
            }
        })
    }

    const handleFieldChange = (event, type) => {
        switch(type) {
            case 'searchKeyword': 
                setSearchKeyword(event.target.value)
                handleFilter(event.target.value)
                break;
        }
    };

    function handleFilter(search) {
        let bldgs = allBuildings

        if(bldgs.length > 0 && search.length > 0) {
            bldgs = bldgs.filter(s => {
                let include = false

                if(
                    (s.name && search &&
                        s.name.toLowerCase().indexOf(search.toLowerCase()) >= 0
                    ) || 
                    (s.address && search &&
                        s.address.toLowerCase().indexOf(search.toLowerCase()) >= 0
                    )
                ) {
                    include = true
                }

                return include
            })
        }

        setBuildings(bldgs)
    }

    return (
        <div className="inner">
            <LoggedInTopMenu />
            <div className={classes.content}>
                <Grid
                justify="space-between"
                container
                >
                <Hidden smDown>
                    <div className={classes.sideMenu}>
                    <SideMenu />
                    </div>
                </Hidden>
                <div className={classes.mainContent}>
                    <div className={classes.article}>
                        <ToastContainer />
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                            <a key="1" href="#" className={classes.activePageHeader}>{t('dashboard.buildings')}</a>  
                            {roleId == 3 &&
                                <a className={classes.addService} href={'/building/0'}>
                                    <AddIcon className={classes.addIcon} />
                                    <div className={classes.addServiceText}>{t('buildings.addabuilding')}</div>
                                </a>
                            }
                        </div>
                        <div className={classes.filterContainer}>
                            <div>
                                <TextField 
                                    id="searchKeyword"
                                    label={t('dashboard.search')} 
                                    className={classes.input}
                                    placeholder={t('dashboard.search')}
                                    value={searchKeyword || ''}
                                    onChange={(event) => handleFieldChange(event, 'searchKeyword')}
                                />
                            </div>
                        </div>
                        <div style={{marginTop:20}}>
                            <DataTable
                                columns={columns}
                                data={buildings}
                                pagination
                                paginationResetDefaultPage={resetPaginationToggle}
                                persistTableHead
                                fixedHeader
                            />
                        </div>
                    </div>
                </div>
                </Grid>
            </div>
        </div>
    );
};
  
export default Buildings;